// Scroll up on each new step for mobile devices
export const scrollTopFunctionHelper = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};
